<script>
import { formatMoney } from 'accounting';
import { USD_SYMBOL } from '~/javascripts/constants';
import TransactionCard from './transaction_card.vue';
import TransactionLineItem from './transaction_line_item.vue';

export default {
  name: 'PurchaseSummaryCard',
  components: {
    TransactionCard,
    TransactionLineItem,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    pricePerUnit: {
      type: Number,
      required: true,
    },
    chargeDescription: {
      type: String,
      required: false,
      default: '',
    },
    quantity: {
      type: Number,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    subtotal: {
      type: Number,
      required: true,
    },
    tax: {
      type: Number,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
  },
  computed: {
    pricePerUnitFormatted() {
      // The design requires pricePerUnit to be formatted with no decimal point,
      // hence these parameters
      return formatMoney(this.pricePerUnit, USD_SYMBOL, '', '', '', 0, 0);
    },
    purchaseDetailsText() {
      const purchaseDetails =
        `${this.quantity} x ${this.pricePerUnitFormatted} ${this.chargeDescription}`.trim();
      return `${this.productName} (${purchaseDetails})`;
    },
  },
  methods: {
    formatMoney,
  },
};
</script>

<template>
  <transaction-card :title="__('Purchase summary')">
    <transaction-line-item
      :is-loading="loading"
      :value="formatMoney(price)"
      :description="purchaseDetailsText"
      :top-border-enabled="false"
      data-testid="subTitle"
      :label="__('Price')"
    />

    <slot name="price-additional-info"></slot>

    <transaction-line-item
      :is-loading="loading"
      :value="formatMoney(subtotal)"
      :label="__('Subtotal')"
    />

    <transaction-line-item
      :is-loading="loading"
      :value="formatMoney(tax)"
      :label="__('Estimated taxes')"
    />
  </transaction-card>
</template>
